/* Atmosense: product page scripts. Loaded with defer only on this page.
   One-accordion-open-at-a-time is handled site-wide by atmo-accordion.js. */

/* Links such as #faq-wifi open that answer */
(function () {
  function openFromHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (el && el.tagName === 'DETAILS') { el.open = true; el.scrollIntoView({ block: 'start' }); }
  }
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openFromHash); else openFromHash();
})();

/* Monitoring carousel */
(function () {
  var track = document.getElementById('atmo-metrics-track');
  var tabsWrap = document.getElementById('atmo-metrics-tabs');
  var prevBtn = document.getElementById('atmo-metrics-prev');
  var nextBtn = document.getElementById('atmo-metrics-next');
  if (!track || !tabsWrap || !prevBtn || !nextBtn) return;

  var slides = Array.prototype.slice.call(track.querySelectorAll('.atmo-metrics__slide'));
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var current = 0;

  slides.forEach(function (slide, i) {
    var tab = document.createElement('button');
    tab.type = 'button';
    tab.className = 'atmo-metrics__tab';
    tab.setAttribute('role', 'tab');
    tab.setAttribute('aria-current', i === 0 ? 'true' : 'false');
    tab.innerHTML = '<span class="atmo-metrics__tab-index">' + (i + 1) + '</span> ' + slide.dataset.tab;
    tab.addEventListener('click', function () { scrollToSlide(i); });
    tabsWrap.appendChild(tab);
  });
  var tabs = Array.prototype.slice.call(tabsWrap.children);

  function setActive(i) {
    current = i;
    tabs.forEach(function (t, idx) { t.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
    prevBtn.disabled = i === 0;
    nextBtn.disabled = i === slides.length - 1;
  }

  function scrollToSlide(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    var slide = slides[i];
    track.scrollTo({
      left: slide.offsetLeft - track.offsetLeft,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
    setActive(i);
  }

  prevBtn.addEventListener('click', function () { scrollToSlide(current - 1); });
  nextBtn.addEventListener('click', function () { scrollToSlide(current + 1); });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = slides.indexOf(entry.target);
          if (idx !== -1) setActive(idx);
        }
      });
    }, { root: track, threshold: 0.6 });
    slides.forEach(function (slide) { observer.observe(slide); });
  }

  setActive(0);
})();